import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { BrowserRouter as Router, Routes, Route, Navigate, useHistory } from 'react-router-dom';

import Topbar from './comps/Topbar';
import RightSidebar from './comps/RightSidebar';
import Dashboard from '../dashboard';
import Information from '../information';
import Reporting from '../reporting';
import UsersManagement from '../users';
import Operations from '../operations';
import { DashboardContext, DashboardProvider } from 'context/DashboardContext';
import useScreen from 'hooks/useScreen';

const Holder = styled(Container)`
    background-color: #535559;
	overflow-x: hidden;
`;

const HomePage = () => {
	const { isMobile, lessThan900 } = useScreen();

	return (
		<Holder fluid>
			<Row>
				<Topbar />
			</Row>
			<Row>
				<Col
					xxl={lessThan900 ? 12 : 10}
					xl={lessThan900 ? 12 : 10}
					lg={lessThan900 ? 12 : 9}
					md={lessThan900 ? 12 : 9}
					sm={lessThan900 ? 12 : 8}
					className={`${lessThan900 ? 'pe-4' : ''}`}
				>
					<Routes>
						<Route
							path="/dashboard"
							element={
								<DashboardProvider>
									<Dashboard />
								</DashboardProvider>
							}
						/>
						<Route path="/information" element={<Information />} />
						<Route path="/reporting" element={<Reporting />} />
						<Route path="/users" element={<UsersManagement />} />
						<Route path="/operations" element={<Operations />} />
						<Route path="/" element={<Navigate replace to="/admin/dashboard" />} />
					</Routes>
				</Col>
				<Col
					xxl={lessThan900 ? 0 : 2}
					xl={lessThan900 ? 0 : 2}
					lg={lessThan900 ? 0 : 3}
					md={lessThan900 ? 0 : 3}
					sm={lessThan900 ? 0 : 4}
				>
					<RightSidebar />
				</Col>
			</Row>
		</Holder>
	);
};

export default HomePage;
